<template>
  <div class="animated fadeIn">
    <Alerts ref="alert"/>
    <Forms ref="frmSearch"
           :title="$lang.EmployeeBoard.Search.TitleForm"
           :showClearButton="true"
           :showSearchButton="true"
           :showNewButton="true"
           :messageTipFooter="$lang.Common.SelectOrEnterInformationToSearch"
           v-on:Clear="onClear"
           v-on:Search="onClickSearch"
           v-on:New="onNew">
      <div class="form-group row">
        <div class="col-md-4">
          <label for="cbxInsure">{{$lang.EmployeeBoard.Search.LabelSituation}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.situacao.value" :options="form.situacao.options" >
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                <option :value="0">{{$lang.EmployeeBoard.TextSituation0}}</option>
                <option :value="1">{{$lang.EmployeeBoard.TextSituation1}}</option>
                <option :value="2">{{$lang.EmployeeBoard.TextSituation2}}</option>
                <option :value="3">{{$lang.EmployeeBoard.TextSituation3}}</option>
                <option :value="-1">{{$lang.EmployeeBoard.TextSituation_1}}</option>
                <option :value="-2">{{$lang.EmployeeBoard.TextSituation_2}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxInsure">{{$lang.EmployeeBoard.Search.LabelConstructions}}:</label>
          <autocomplete-z ref="obraRHTypeahead"
                          :placeholder="$lang.EmployeeBoard.Search.PlaceholderConstructions"
                          iconClass="fas fa-hard-hat"
                          :serializer="(obra) => obra.codigo + ' - ' + obra.nome"
                          :debounceLength="2"
                          :formField="form.obraRHID"
                          v-on:search="onSearchObraRH"
                          v-on:changeCode="onChangeCodeObraRH"/>
        </div>
        <div class="col-md-4">
          <label for="txtInsured"> {{$lang.EmployeeBoard.Search.LabelResponsible}}:</label>
          <autocomplete-z ref="responsavelTypeahead"
                          :placeholder="$lang.EmployeeBoard.Search.PlaceholderResponsible"
                          iconClass="fas fa-users"
                          :serializer="(responsavel) => responsavel.codigo + ' - ' + responsavel.nome"
                          :debounceLength="3"
                          :formField="form.responsavelID"
                          v-on:search="onSearchResponsavel"
                          v-on:changeCode="onChangeCodeResponsavel" />
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-4">
          <label for="cbxInsure"> {{$lang.EmployeeBoard.Search.LabelRegional}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          class="col-2 text-upper"
                          style="height: calc(2.09375rem + 2px);"
                          :placeholder="$lang.Common.PlaceholderCode"
                          v-model="form.secaoRH.value"
                          :maxlength="form.secaoRH.maxlength"
                          :state="form.secaoRH.state"
                          @focus="onClearSection"
                          v-on:change="onChangeCodeSection"
            />&nbsp;
            <b-form-select v-model="form.secaoRHID.value"
                           :options="form.secaoRHID.options" >
              <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtCodePeople"><small v-show="form.dataInicioSolicitacao.required" class="text-danger">*</small> {{$lang.EmployeeBoard.Search.LabelStartRequest}}:</label>
          <div class="input-group">
            <b-form-input type="date"
                          name="txtDataInicioSolicitacao"
                          ref="dataInicioSolicitacaoComp"
                          v-model="form.dataInicioSolicitacao.value"
                          :required="form.dataInicioSolicitacao.required"
                          :state="form.dataInicioSolicitacao.state" />
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtCodePeople"><small v-show="form.dataFimSolicitacao.required" class="text-danger">*</small> {{$lang.EmployeeBoard.Search.LabelEndRequest}}:</label>
          <div class="input-group">
            <b-form-input type="date"
                          name="txtDataFimSolicitacao"
                          ref="dataFimSolicitacaoComp"
                          v-model="form.dataFimSolicitacao.value"
                          :required="form.dataFimSolicitacao.required"
                          :state="form.dataFimSolicitacao.state" />
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxInsure"> {{$lang.EmployeeBoard.Search.LabelClient}}:</label>
          <autocomplete-z ref="clienteRHTypeahead"
                          :placeholder="$lang.EmployeeBoard.Search.PlaceholderClient"
                          iconClass="fas fa-user-tie"
                          :serializer="(cli) => cli.codigo + ' - ' + cli.nome"
                          :debounceLength="3"
                          :formField="form.clienteRHID"
                          v-on:search="onSearchClienteRH"
                          v-on:changeCode="onChangeCodeClienteRH" />
        </div>
      </div>
    </Forms>
    <Tables ref="tableGrid"
            :columns="[
              '',
              $lang.EmployeeBoard.Search.DataTable.Order,
              $lang.EmployeeBoard.Search.LabelRegional,
              $lang.EmployeeBoard.Search.DataTable.DateRequest,
              $lang.EmployeeBoard.Search.DataTable.Requester,
              $lang.EmployeeBoard.Search.LabelResponsible,
              $lang.EmployeeBoard.Search.LabelConstructions,
              $lang.Common.LabelCity,
              $lang.EmployeeBoard.Search.LabelSituation,
              $lang.Common.DataTable.Actions
            ]"
            :showFullscreen="true"
            :messageTipFooter="$lang.Common.ClickToSelect"
            :showPrint="true"
            :showDownload="false"
            v-on:Load="onSearch"
            v-on:Fullscreen="onFullscreen"
            v-on:SaveFile="onDownload"
            v-on:Print="onPrint">
      <tr v-for="(obj, index) in this.objList" v-bind:key="index">
        <TableColumn :IsCustom="true" :status="obj.status">
          <b-form-checkbox :id="`cbxQuadro-${index}`"
                           v-model="obj.checked"
                           :name="`cbxQuadro-${index}`"
                           :value="true"
                           size="sm" />
        </TableColumn>
        <TableColumn :IsText="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.pedido" />
        <TableColumn :IsText="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.secaoRH.nome" />
        <TableColumn :IsDatetime="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.dataCriacao" />
        <TableColumn :IsText="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.nomeContaAcao" />
        <TableColumn :IsText="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.responsavel ? obj.responsavel.nome : ''" />
        <TableColumn :IsText="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.obraRH ? obj.obraRH.nome : ''" />
        <TableColumn :IsText="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.cidade && obj.cidade.nome ? obj.cidade.nome + ' - ' + (obj.cidade.estado ? obj.cidade.estado.sigla : '') : ''" />
        <TableColumn :IsCustom="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status">
          <span v-if="obj.situacao === null || obj.situacao === 0" class="badge badge-default badge-pd text-toupper">{{$lang.EmployeeBoard.TextSituation0}}</span>
          <span v-else-if="obj.situacao === 1" class="badge badge-wait text-toupper">{{$lang.EmployeeBoard.TextSituation1}}</span>
          <span v-else-if="obj.situacao === 2" class="badge badge-wait text-toupper">{{$lang.EmployeeBoard.TextSituation2}}</span>
          <span v-else-if="obj.situacao === 3" class="badge badge-success badge-pd text-toupper">{{$lang.EmployeeBoard.TextSituation3}}</span>
          <span v-else-if="obj.situacao === -1" class="badge badge-danger badge-pd-disapproval text-toupper">{{$lang.EmployeeBoard.TextSituation_1}}</span>
          <span v-else-if="obj.situacao === -2" class="badge badge-danger badge-pd-disapproval text-toupper">{{$lang.EmployeeBoard.TextSituation_2}}</span>
        </TableColumn>
        <TableColumn :IsActionsButtons="true" :HasChange="false" :HasDelete="obj.situacao === null || obj.situacao === 0" v-on:Delete="onDeleteBoard(obj)" />
      </tr>
    </Tables>
  </div>
</template>

<script>
import EmployeeBoardSearch from './search.js'

export default EmployeeBoardSearch
</script>

<style scoped>
.custom-group-addon {
  padding: 0.4rem 1rem;
  display: block;
  position: absolute;
  z-index: 9;
  cursor: pointer;
}
.badge-pd {
  padding: 5px 5px 3px 5px;
  color: #000;
}
.badge-pd-disapproval {
  padding: 5px 5px 3px 5px;
}
.badge-wait {
  background-color: #ffc107;
  color: #000;
  padding: 5px 5px 3px 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/finance/employeeboard/search/search.vue